// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import styled from 'styled-components'

import { TypeStyle, fromMd } from '@syconium/little-miss-figgy'

export const Container = styled(TypeStyle.BodySmall).attrs({
  asTag: 'div',
})`
  display: inline-block;
  font-weight: ${o => o.theme.typography.font.weight[400]};
  margin-top: ${o => o.theme.spacing(3)};

  ${fromMd} {
    margin-top: ${o => o.theme.spacing(4)};
  }
`

export const StyleLink = styled(Link)`
  text-decoration: underline;
  font-weight: ${o => o.theme.typography.font.weight[600]};
  color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  &:hover {
    color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.subtle};
  }
`
